import { Agreement01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Section } from "views/applications-id-report/components/Section";
import { SectionIcon } from "../components/SectionIcon";
import { ConsentsList } from "../components/ConsentsList";
import { CapturedConsent, SelectedLender } from "../types";

export const EConsentSlice = ({
  consents,
  lenders
}: {
  consents: CapturedConsent[];
  lenders: SelectedLender[];
}) => {
  if (consents.length === 0) return null;

  return (
    <Section
      sectionTitle="E-consent"
      icon={<SectionIcon icon={Agreement01Icon} />}
    >
      <ConsentsList consents={consents} lenders={lenders} />
    </Section>
  );
};
